import styled from 'styled-components';
import { Link } from "react-router-dom";
import colors from 'constants/colors';

export const Menu = styled.nav`
  list-style: none;
  display: ${({ open }) => (open? 'flex': 'none')};
  background-color: ${colors.black4};
  flex-flow: column nowrap;
  position: fixed;
  top: 50px;
  right: 0;
  width: 212px;
  padding: 50px 0 21px 0;
  z-index: 1000;

  @media only screen and (min-width: 767px) and (max-width: 1200px) {
    width: 100%;
    padding: 70px 0 110px 0;
  }

  @media only screen and (max-width: 767px) {
    width: 100%;
    padding: 60px 0 39px 0;
  }

  .active {
    color: ${colors.white};
  }
`;

export const Title = styled.div`
  position: absolute;
  top: 0px;
  right: 20px;
  line-height: 50px;
  font-size: 30px;
  font-weight: 300;
  color: ${colors.white};

  img {
    width:20px;
    height:20px;
    cursor: pointer;
  }

  @media only screen and (min-width: 767px) and (max-width: 1200px) {
    left: 27px;
    top: 10px;
  }

  @media only screen and (max-width: 767px) {
    left: 20px;
    top: 0;
    img {
      width:15px;
      height:15px;
    }
  }
`;

export const Item = styled(Link)`
  padding: 8px 22px;
  margin: 0 0 5px 0;
  color: ${colors.dimGrey};
  background-color: ${colors.black4};
  font-size: 24px;
  font-weight: bold;
  text-decoration: none;

  :hover {
    color: ${colors.white};
    background-color: ${colors.darkBlue};
    border-left: 5px solid ${colors.lightBlue};
    padding-left: 17px;
  }

  @media only screen and (max-width: 1200px) {
    ${({ desktop }) => (desktop ? `display: none;` : null)};
  }

  @media only screen and (min-width: 767px) and (max-width: 1200px) {
    font-size: 20px;
    font-weight: 600;
    padding: 6px 27px;
    :hover {
      padding-left: 22px;
    }
  }

  @media only screen and (max-width: 767px) {
    font-size: 20px;
    font-weight: 600;
    padding: 4px 20px;
    :hover {
      padding-left: 15px;
    }
  }
`;

export const Logout = styled.div`
  padding: 8px 22px;
  margin: 0 0 5px 0;
  color: ${colors.red};
  background-color: ${colors.black4};
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;

  :hover {
    background-color: ${colors.darkBlue};
    border-left: 5px solid ${colors.lightBlue};
    padding-left: 17px;
  }

  @media only screen and (min-width: 767px) and (max-width: 1200px) {
    font-size: 20px;
    font-weight: 600;
    padding: 6px 27px;
    :hover {
      padding-left: 22px;
    }
  }

  @media only screen and (max-width: 767px) {
    font-size: 20px;
    font-weight: 600;
    padding: 4px 20px;
    :hover {
      padding-left: 15px;
    }
  }
`;